
export default {
    name: 'HomeCollections',
    props: {
        collections: {
            type: Array,
            required: true,
        },
    },
    computed: {
        visibleCollections() {
            return this.collections.filter(collection => collection.slug && this.getImage(collection));
        },
    },
    methods: {
        getImage(collection) {
            if (!collection.image) {
                return null;
            }

            return (collection.image.sizes && (collection.image.sizes.small || collection.image.sizes.big))
                || collection.image.path
                || null;
        },
        getImageSrcset(collection) {
            const sizes = collection.image && collection.image.sizes;

            if (!sizes || !sizes.small || !sizes.big) {
                return null;
            }

            return `${sizes.small} 1x, ${sizes.big} 2x`;
        },
    },
}
